import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

@protectedRoute({ features: ['spider.market_segment_drilldown'] })
export default class HotelSegmentDrilldownRoute extends Route {
  model() {
    return this.modelFor('hotel');
  }
}
